import { NoImage } from "../../../../assets/NoImage";

export const SlideCardImage = ({ src, alt }: { src: string; alt: string }) =>
    src ? (
        <img className="slideCard__image" src={src} alt={alt} draggable={false} />
    ) : (
        <div className="logoPlaceholder">
            <NoImage />
            <span>Upload Image</span>
        </div>
    );